import { translations } from "@/core/constants/translation";
import useLanguageStore from "@/core/states/language-store";

export default function useTranslation() {
  const { language, setLanguage } = useLanguageStore();

  const getText = (key: keyof typeof translations, options?: { number?: number }) => {
    let number;
    if (key === "workspace_6") {
      number = options?.number ?? 0;
      if (language === "english") return `${number} ${number <= 1 ? "Manager" : "Managers"}`;
      else return `매니저 ${number}명`;
    } else if (key === "workspace_5") {
      number = options?.number ?? 0;
      if (language === "english") return `${number} ${number <= 1 ? "FAQ" : "FAQs"}`;
      else return `질문 ${number}개`;
    } else if (key === "workspace_item") {
      number = options?.number ?? 0;
      if (language === "english") return `${number} ${number <= 1 ? "FAQ" : "FAQs"}`;
      else
        return `FAQ
      ${number}개`;
    } else return translations[key][language];
  };

  const getDateFormat = (date: string) => {
    return new Date(date).toLocaleDateString(language === "english" ? "en-US" : "ko-KR", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };

  return { getText, language, setLanguage, getDateFormat };
}
